/**
 * Define the options for confirmation popover component.
 */
export interface IConfirmationPopoverOptionsInterface {
  /**
   * The popover title
   */
  title?: string;
  /**
   * The popover message
   */
  message?: string;
  /**
   * The popover confirmation button text
   */
  confirmText?: string;
  /**
   * The popover cancel button text
   */
  cancelText?: string;
  /**
   * The popover confirm button type e.g. `success`, `danger` etc
   */
  confirmButtonType?: string;
  /**
   * The popover cancel button type  e.g. `success`, `danger` etc
   */
  cancelButtonType?: string;
  /**
   * The popover placement. Can be `top`, `bottom`, `left`, `right`
   */
  placement?: string;
  /**
   * Which button to cancel. Can be either `confirm` or `cancel`
   */
  focusButton?: string;
  /**
   * Whether to hide the confirmation button
   */
  hideConfirmButton?: boolean;
  /**
   * Whether to hide the cancel button
   */
  hideCancelButton?: boolean;
  /**
   * A custom CSS class to be added to the popover
   */
  popoverClass?: string;
  /**
   * Whether to append the popover to the document body
   */
  appendToBody?: boolean;
}

/**
 * Represents the options for confirmation popover component.
 */
export class ConfirmationPopoverOptions implements IConfirmationPopoverOptionsInterface {
  public title: string;
  public message: string;
  public confirmText = 'Confirm';
  public cancelText = 'Cancel';
  public confirmButtonType = 'success';
  public cancelButtonType = 'default';
  public placement = 'top';
  public focusButton: string;
  public hideConfirmButton = false;
  public hideCancelButton = false;
  public popoverClass = '';
  public appendToBody = false;
}
